import { Download, Smartphone } from "lucide-react";

// Hidden inside the Android app itself (Capacitor injects window.Capacitor)
export default function AppBanner() {
  if (typeof window !== "undefined" && window.Capacitor?.isNativePlatform?.()) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-6" data-testid="app-download-banner">
      <div className="flex flex-col items-start gap-4 rounded-3xl border border-blue-100 bg-gradient-to-r from-blue-50 via-white to-sky-50 p-6 sm:flex-row sm:items-center">
        <img src="/icon-192.png" alt="GPRTU app" className="h-16 w-16 rounded-2xl shadow-[0_10px_24px_-10px_rgba(0,82,255,0.7)]" />
        <div className="flex-1">
          <div className="font-display text-xl font-extrabold">Get the GPRTU app</div>
          <p className="text-sm text-slate-600">Book seats, pay with MoMo and keep your QR tickets on your Android phone.</p>
        </div>
        <a href="/downloads/gprtu-intercity.apk" download className="btn-press inline-flex items-center gap-2 rounded-full bg-[#0052FF] px-5 py-3 text-sm font-bold text-white hover:bg-[#0041CC]" data-testid="download-apk-link">
          <Download className="h-4 w-4" /> Download for Android
        </a>
        <span className="hidden items-center gap-1 text-xs text-slate-500 lg:flex"><Smartphone className="h-3.5 w-3.5" />Android 5.1+</span>
      </div>
    </section>
  );
}
